export default "__VITE_ASSET__M91Xpqhj__"